import { FRAMAuthUISettings } from './framauthui-config';
import { InjectionToken } from '@angular/core';

export interface FRAMAuthUIToken {
    settings: Partial<FRAMAuthUISettings>;
}

export const FRAMAUTHUI_TOKEN = new InjectionToken<FRAMAuthUIToken>('FRAMAUTHUI');
